export default "__VITE_ASSET__CJ9fb3I$__"